var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isMobile)?_c('i-header'):_vm._e(),_c('i-aside'),_c('home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }